import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Field } from '../../models/field.model';

@Injectable({
  providedIn: 'root',
})
export class FieldService {
  private readonly http = inject(HttpClient);

  getFields(farmId?: number): Observable<Field[]> {
    let params = new HttpParams();

    if (farmId !== undefined) {
      params = params.set('farmId', farmId);
    }

    return this.http.get<Field[]>(
      `${environment.apiUrl}/fields`,
      {
        params,
      },
    );
  }
}
